module.exports = __webpack_public_path__ + "img/homepage_3@2x.b06c4188.jpg";